import { isEmpty } from "lodash";

export function auth() {
  const token = localStorage.getItem("token");
  const iframeToken = localStorage.getItem("iframeToken");
  const guestToken = localStorage.getItem("guestToken");

  // Determine which token to use (iframeToken > guestToken > token)
  const activeToken = !isEmpty(iframeToken) ? iframeToken : !isEmpty(guestToken) ? guestToken : token;

  // Debug log
  // console.log('[Auth] Tokens:', { iframeToken: !!iframeToken, token: !!token, active: !!activeToken });

  // Base headers
  const headers = {
    "accept-language": "en",
  };

  // Add Authorization only if we have a token
  if (!isEmpty(activeToken)) {
    headers.Authorization = `Bearer ${activeToken}`;
  }

  return { headers };
}
